import React from "react";
import PvContainer from "./../containers/PvContainer";

function FormPV() {
  return <PvContainer></PvContainer>;
}

export default FormPV;
